import { Upload, message } from "antd";
import type { RcFile } from "antd/es/upload";

const duration = 5;

export default function videoValidation(maxSize: number, unit: "MB" | "KB") {
  const maxSizeInBytes = unit === "MB" ? maxSize * 1024 * 1024 : maxSize * 1024;

  return function (file: RcFile) {
    const isVideo = file.type === "video/mp4";
    const isSizeValid = file.size <= maxSizeInBytes;

    if (!isVideo) {
      message.error(`${file.name} is not a MP4 file`, duration);
    }
    if (!isSizeValid) {
      const maxSizeDisplay = unit === "MB" ? maxSize + "MB" : maxSize + "KB";
      message.error(
        `Please upload an video that is less than ${maxSizeDisplay}.`,
        duration
      );
    }

    return (isVideo && isSizeValid) || Upload.LIST_IGNORE;
  };
}
